type PlainResponse<T = any> = {
	data?: T;
	meta?: any;
};

export const normalizeRecordResponse = <T = any>(
	response: PlainResponse<T> = {},
): { data: T | Record<string, never> } => {
	return { data: response.data || {} };
};

export const normalizeCollectionResponse = <T = any>(response: PlainResponse<T[]> = {}): { data: T[]; meta: any } => {
	return { data: response.data || [], meta: response.meta || {} };
};
